import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType, ConsumerOfPatientSchema } from '../base/baseSchema.js';

export const ExportTextToBucketBlockConfigSchema = z.object({
  patient: ConsumerOfPatientSchema({ isRequired: false }),
  source: z.string().min(1, { message: 'Data to export is required' }),
});
export type ExportTextToBucketBlockConfig = z.infer<typeof ExportTextToBucketBlockConfigSchema>;

export const ExportTextToBucketBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.ExportTextToBucket),
  config: ExportTextToBucketBlockConfigSchema,
});
export type ExportTextToBucketBlock = z.infer<typeof ExportTextToBucketBlockSchema>;
